import React, { useState } from "react";
import { Select, Button, Popconfirm, Space } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faSync, faFolderOpen } from "@fortawesome/free-solid-svg-icons";

// Thanh thao tác hàng loạt — hiện khi có dòng được chọn.
function BulkActionBar({ selectedCount, categories, onBulkDelete, onBulkMove, onBulkRecheck, loading }) {
    const [moveCategory, setMoveCategory] = useState(undefined);
    if (!selectedCount) return null;

    const categoryOptions = categories.map((c) => ({
        label: c.categoryName || c.categoryId,
        value: c.categoryId,
    }));

    return (
        <div className="flex flex-wrap items-center gap-x-3 gap-y-2 bg-blue-50 border border-blue-200 rounded px-3 py-2">
            <span className="font-medium">Đã chọn {selectedCount}</span>
            <Space>
                <Select
                    placeholder="Chuyển danh mục"
                    options={categoryOptions}
                    value={moveCategory}
                    onChange={setMoveCategory}
                    className="w-36 sm:w-44"
                    size="small"
                />
                <Button
                    size="small"
                    icon={<FontAwesomeIcon icon={faFolderOpen} />}
                    disabled={!moveCategory}
                    onClick={() => onBulkMove(moveCategory)}
                >
                    Chuyển
                </Button>
            </Space>
            <Button
                size="small"
                icon={<FontAwesomeIcon icon={faSync} />}
                loading={loading}
                onClick={onBulkRecheck}
            >
                Kiểm tra tồn kho
            </Button>
            <Popconfirm
                title={`Xoá ${selectedCount} video đã chọn?`}
                onConfirm={onBulkDelete}
                okText="Xoá"
                cancelText="Huỷ"
                okButtonProps={{ danger: true }}
            >
                <Button size="small" danger icon={<FontAwesomeIcon icon={faTrash} />}>
                    Xoá
                </Button>
            </Popconfirm>
        </div>
    );
}

export default BulkActionBar;
